import { createAction, props } from '@ngrx/store';
import {
  Task,
  Comment,
  TaskDetails,
  StatusDto,
} from '../../../core/interfaces';
import { TaskFilter } from './tasks.reducer';
import { baseProps } from '../../../core/store/actions-base';

export const fetchTasks = createAction(
  '[@ciso/tasks] fetchTasks',
  baseProps<{ controlId?: string; homeTasks?: boolean }>(),
);

export const fetchTasks_Success = createAction(
  '[@ciso/tasks] fetchTasks_Success',
  props<{ tasks: Task[] }>(),
);

export const fetchTasks_Failure = createAction(
  '[@ciso/tasks] fetchTasks_Failure',
);

export const addTaskFilter = createAction(
  '[@ciso/tasks] addTaskFilter',
  props<{ filterType: keyof TaskFilter; value: any; displayName: string }>(),
);

export const removeTaskFilter = createAction(
  '[@ciso/tasks] removeTaskFilter',
  props<{ filterType: keyof TaskFilter; value: any }>(),
);

export const removeAllFilters = createAction('[@ciso/tasks] removeAllFilters');

export const changeTaskStatus = createAction(
  '[@ciso/tasks] changeTaskStatus',
  baseProps<{
    taskId: string;
    status: number;
    outputText?: string | null;
    controlId?: string;
  }>(),
);

export const fetchTaskStatuses = createAction(
  '[@ciso/tasks] fetchTaskStatuses',
  baseProps(),
);

export const fetchTaskStatuses_Success = createAction(
  '[@ciso/tasks] fetchTaskStatuses_Success',
  props<{ taskStatuses: StatusDto[] }>(),
);

export const fetchTaskStatuses_Failure = createAction(
  '[@ciso/tasks] fetchTaskStatuses_Failure',
);

export const changeTaskStatus_Success = createAction(
  '[@ciso/tasks] changeTaskStatus_Success',
  props<{ taskId: string; task: Task }>(),
);

export const changeTaskStatus_Failure = createAction(
  '[@ciso/tasks] changeTaskStatus_Failure',
  props<{ taskId: string; status: number }>(),
);

export const markTaskAsReviewed = createAction(
  '[@ciso/tasks] markTaskAsReviewed',
  props<{ taskId: string }>(),
);

export const removeTaskDetailsSidebar = createAction(
  '[@ciso/tasks] removeTaskDetailsSidebar',
);

export const fetchTaskDetails = createAction(
  '[@ciso/tasks] fetchTaskDetails',
  baseProps<{ taskId: string }>(),
);

export const fetchTaskDetails_Success = createAction(
  '[@ciso/tasks] fetchTaskDetails_Success',
  props<{ taskDetails: TaskDetails }>(),
);

export const markTasksAsReviewed = createAction(
  '[@ciso/tasks] markTasksAsReviewed',
  baseProps<{ controlId?: string }>(),
);

export const markTasksAsReviewed_Success = createAction(
  '[@ciso/tasks] markTasksAsReviewed_Success',
);

export const resetTasksStore = createAction('[@ciso/tasks] resetTasksStore');

export const addComment = createAction(
  '[@ciso/tasks] addComment',
  props<{ taskId: string; commentText: string }>(),
);

export const addComment_Success = createAction(
  '[@ciso/tasks] addComment_Success',
  props<{ comment: Comment }>(),
);

export const setTaskDetailsCommentPending = createAction(
  '[@ciso/tasks] setTaskDetailsCommentPending',
  props<{ pending: boolean }>(),
);

export const setTaskDetailsCommentFailed = createAction(
  '[@ciso/tasks] setTaskDetailsCommentFailed',
  props<{ failed: boolean; errorMessage?: string }>(),
);

export const toggleSidebar = createAction(
  '[@ciso/tasks] toggleSidebar',
  props<{ showSidebar: boolean }>(),
);
